import Vue from 'vue';
import Http from 'axios';
import Router from '@app/router';
import Store from '@app/store';
import Tracking from '@app/tracking';
import '@app/directives/eventTracking';
import '@app/directives/contentParser';
import '@app/directives/imageLazyLoad';
import '@app/directives/focusArea';
import '@app/directives/schema';
import '@app/directives/observe';
import '@app/global/icons';
import '@app/modules/RF/CMS';
// import '@app/modules/RF/Blog'
// import '@app/modules/RF/Event'
import '@app/modules/RF/Company';
import '@app/modules/RF/Locator';
import '@app/modules/Woodrangers/Ecommerce';
import '@app/modules/RF/Member';
// import '@app/modules/RF/Scout24'
// import '@app/modules/RF/Search'
// import '@app/modules/RF/Shopify'
import AppGlobals from '@app/plugins/AppGlobals';
import App from '@app/components/App.vue';
import Link from '@app/components/Link.vue';
import Container from '@app/components/Layout/Container.vue';
import StackLayout from '@app/components/Layout/Stack.vue';
import GridRow from '@app/components/Layout/GridRow.vue';
import GridColumn from '@app/components/Layout/GridColumn.vue';
import Spinner from '@app/components/Spinner.vue';
import ImageResponsive from '@app/components/ImageResponsive.vue';
Vue.use(AppGlobals);
Vue.component('link-component', Link);
Vue.component('StackLayout', StackLayout);
Vue.component('Container', Container);
Vue.component('GridRow', GridRow);
Vue.component('GridCol', GridColumn);
Vue.component('Spinner', Spinner);
Vue.component('ImageResponsive', ImageResponsive);
// Add Laravel CSRF token to axios defaults
var csrfMeta = document.querySelector('meta[name="csrf-token"]');
if (csrfMeta) {
    Http.defaults.headers.common['X-CSRF-TOKEN'] = csrfMeta.getAttribute('content');
    Http.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
}
else {
    throw new Error('CSRF Token meta tag not found');
}
// Remove static javascript for language and frontend user initializing
var jsInitEl = document.getElementById('jsInit');
if (jsInitEl && jsInitEl.parentNode) {
    jsInitEl.parentNode.removeChild(jsInitEl);
}
// Start tracking if consent was given or unkonwn
var cookieConsent = Vue.helpers.storage.get('cookie-consent-given');
if (!cookieConsent || cookieConsent == 'yes') {
    Tracking.start();
}
// Initialize Vue application
new Vue({
    el: '#app',
    router: Router,
    data: {
        Store: Store,
    },
    render: function (h) { return h(App); }
});
